/** Month jumped to during this visit, per person-view (user + grid endpoint). Cleared on reload, sign-out and range change. */
export const rememberedMonth = new Map();
export const clearGridMemory = () => rememberedMonth.clear();
